import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchAgentSalesApi } from 'api/agent-sales-api';
import toast from 'react-hot-toast';
import { getErrorString } from 'utils';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  data: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchAgentSalesListing = createAsyncThunk('agents/listing', async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      'q[s]': 'created_at desc',
      ...updatedParamsObject,
    };
    const res = await fetchAgentSalesApi(paramsObj, '');
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const AgentSalesSlice = createSlice({
  name: 'agent-sales',
  initialState,
  reducers: {
    setAgentSalesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAgentSalesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchAgentSalesListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.data = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchAgentSalesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setAgentSalesActiveColumn } = AgentSalesSlice.actions;
export default AgentSalesSlice.reducer;
